/**
 * Support-chat accounts that post automatically (Cleatus, id 1647). Their
 * conversation still lists and sorts by recency for staff, but it never reads
 * as unread: no unread dot or styling in the staff list, no sidebar / tab bar
 * badge count, and no DM sound. The server keeps the same list for admin push
 * (NO_ADMIN_PUSH_SENDER_IDS in services/directMessageReceipt/service.js).
 */
export const AUTOMATED_DM_USER_IDS: ReadonlySet<number> = new Set([1647]);

/** True when a support-chat id (the member's user id) is an automated account. */
export function isAutomatedDmUser(id: API.Id | string | null | undefined): boolean {
  return id !== null && id !== undefined && AUTOMATED_DM_USER_IDS.has(Number(id));
}
